import { createActions } from 'redux-actions';

import { InsurerTeam } from '@models/InsurerTeam';

export type State = {
  teams: InsurerTeam[];
};

export type StateUpdatePayload = Partial<State>;

export const {
  insurerTeamsFetch,
  stateUpdate,
} = createActions(
  'INSURER_TEAMS_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'FEATURE_INSURER_TEAM',
  },
);
